import React, { useMemo } from 'react';
import classnames from 'classnames';

import styles from './ContentList.module.scss';

interface IProps {
  responsive?: boolean;
  children?: React.ReactNode;
  direction?: 'row' | 'col';
  colNum?: 3 | 4;
  smHideLast?: boolean;
}

function ContentList(props: IProps) {
  const { children, direction = 'row', colNum = 3, responsive = true, smHideLast } = props;

  const listCls = useMemo(() => {
    return classnames(
      styles.list,
      {
        [styles.listRow]: direction === 'row',
        [styles.listCol]: direction === 'col',
        [styles.hideLastChild]: smHideLast,
      },
      styles[`list${colNum}`],
    );
  }, [direction, colNum]);

  const itemCls = useMemo(() => {
    return classnames(
      {
        [styles.item]: responsive,
        [styles.itemExpand]: direction === 'col',
      },
      styles[`itemCol${colNum}`],
    );
  }, [responsive, direction, colNum]);

  return (
    <ul className={listCls}>
      {React.Children.map(children, (element: any, idx) => {
        return (
          <li key={idx} className={itemCls}>
            {React.cloneElement(element, {})}
          </li>
        );
      })}
    </ul>
  );
}

export default ContentList;
